import { render, staticRenderFns } from "./index.vue?vue&type=template&id=437859fc&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=437859fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437859fc",
  null
  
)

export default component.exports